exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-tel,.input-tel__input{height:56px!important;min-height:56px!important}.input-tel__input{background-color:#e8e8e8!important}.country-selector,.country-selector__input{height:56px!important;min-height:56px!important}.country-selector__input{background-color:#e8e8e8!important}.contacts .v-text-field{padding-top:0;margin-top:0}@media (max-width:600px){.transit .v-menu__content{-webkit-box-shadow:none!important;box-shadow:none!important}}.v-select__selection{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:100%}.v-select__selections{-ms-flex-wrap:nowrap!important;flex-wrap:nowrap!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77fe812d","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/transit-osago/TransitOsago.vue
// module id = yf43
// module chunks = 0